import { ICustomer } from '@interfaces/icustomer';
import { IMeta } from '@interfaces/imeta';
import { DataName } from '@utils/constants';
import { isDirection } from '@utils/get-role';
import { isLoading } from '@utils/loading';
import { Button, Card, Icon, PageHeader } from 'antd';
import React, { Component, Fragment } from 'react';
import { CSVLink } from 'react-csv';
import DocumentTitle from 'react-document-title';
import { Link } from 'react-router-dom';
import TableComponent from './libraries/table';

interface IProps {
  fetchCustomerList: (params: any) => void;
  customerList: ICustomer[];
  isFetching: string[];
  metaData: IMeta;
}

const excelHeaders = [
  { label: 'Kode Customer', key: 'code' },
  { label: 'Nama Customer', key: 'name' },
  { label: 'Email', key: 'email' },
  { label: 'No Telepon', key: 'phone' },
  { label: 'Fax', key: 'fax' },
  { label: 'Alamat', key: 'address' },
  { label: 'Kota', key: 'city' },
  { label: 'Nama PIC', key: 'picName' },
  { label: 'No Telepon PIC', key: 'picPhone' },
];

const title = 'Kelola Customer';
const subTitle = 'Daftar Customer';
const direksi = isDirection();
export class PageCustomerComponent extends Component<IProps, any> {
  public render() {
    const { fetchCustomerList, customerList, isFetching, metaData } = this.props;
    const loading = isLoading(isFetching, DataName.CUSTOMER);

    const excelSource = customerList?.map((data) => ({
      code: data.code,
      name: data.name,
      email: data.email || '-',
      phone: data.phone || '-',
      fax: data.fax || '-',
      address: data.address || '-',
      city: data.city || '-',
      picName: data.picName || '-',
      picPhone: data.picPhone || '-',
    }));

    return (
      <Fragment>
        <DocumentTitle title={`${process.env.REACT_APP_PROJECT} - ${title}`} />
        <PageHeader title={title} />
        <Card
          title={subTitle}
          bordered={false}
          extra={[
            <Link key="1" to={`/customer/form`} style={{ marginRight: direksi ? 8 : 0 }}>
              <Button type="primary">
                <Icon type="plus" />
                Tambah Customer
              </Button>
            </Link>,
            direksi && (
              <CSVLink
                key="2"
                data={excelSource}
                headers={excelHeaders}
                filename={`${subTitle}.xls`}
                target="_blank"
              >
                <Button type="primary">
                  <Icon type="edit" />
                  Export to Excel
                </Button>
              </CSVLink>
            ),
          ]}
        >
          <TableComponent
            isFetching={loading}
            fetchDataSource={fetchCustomerList}
            dataSource={customerList}
            meta={metaData}
          />
        </Card>
      </Fragment>
    );
  }
}
export default PageCustomerComponent;
